@let principalCandidates = (this.principalCandidates$ | async) ?? [];
@if (principalCandidates.length > 0) {
  <div class="row mb-2">
    <div class="col-12 col-md">
      <span translate>LEAD_MSG_DUPLICATES_SELECT_PRINCIPAL</span>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-12 col-md">
      <app-generic-grid
        style="height: 300px"
        [data]="principalCandidates"
        [tabViewName]="'modalMarkAsDuplicate'"
        [pageSize]="300"
        (onActionClickedSetRowData)="onSetRowData($event)"
      />
    </div>
  </div>
} @else {
  <p class="text-muted" translate>
    LEAD_LBL_DUPLICATES_EMPTY_PRINCIPAL
  </p>
}
